import { MagnifyingGlassIcon, PlusIcon, ArrowPathIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';

interface ActionBarProps {
  onSearchChange: (value: string) => void;
  onCreateClick: () => void;
  onRefresh?: () => void;
  searchValue: string;
  isRefreshing?: boolean;
}

const ActionBar: React.FC<ActionBarProps> = ({ 
  onSearchChange, 
  onCreateClick, 
  onRefresh,
  searchValue,
  isRefreshing = false
}) => {
  const { t } = useTranslation('forms');

  return (
    <div>
      <div className="mb-5 flex items-center gap-3">
        {/* Search Bar */}
        <label className="input input-bordered flex w-full max-w-xl items-center gap-2 rounded-full">
          <MagnifyingGlassIcon className="h-5 w-5 opacity-60" />
          <input
            type="text"
            placeholder={t('search_placeholder', 'Buscar formularios...')}
            value={searchValue}
            className="w-full grow bg-transparent outline-none"
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </label>

        <button
          className="btn btn-primary btn-sm rounded-full"
          onClick={onCreateClick}
        >
          <PlusIcon className="h-5 w-5" />
          {t('create_form', 'Crear Formulario')}
        </button>

        {onRefresh && (
          <button
            className="btn btn-outline btn-sm rounded-full"
            onClick={onRefresh}
            disabled={isRefreshing}
            title={t('refresh', 'Actualizar')}
          >
            <ArrowPathIcon className={`h-5 w-5 ${isRefreshing ? 'animate-spin' : ''}`} />
            {t('refresh', 'Actualizar')}
          </button>
        )}
      </div>
    </div>
  );
};

export default ActionBar;
